import httpAxiosApi from "../../core/axios.errors.handle";

export const fetchEpayPurposesOfRemittance = async () => {
    return await httpAxiosApi.get('/webapi/finance/epy/dictionaryPurposeOfRemittance').then(
        (response) => {
            return response.data;
        }
    );
}


export const fetchEpayOccupation = async () => {
    return await httpAxiosApi.get('/webapi/finance/epy/dictionaryOccupation').then(
        (response) => {
            return response.data;
        }
    );
}


export const fetchEpayBeneficiaryRelationship = async () => {
    return await httpAxiosApi.get('/webapi/finance/epy/dictionaryBeneficiaryRelationship').then(
        (response) => {
            return response.data;
        }
    );
}

export const fetchEpaySourceOfFunds = async () => {
    return await httpAxiosApi.get('/webapi/finance/epy/dictionarySourceOfFunds').then(
        (response) => {
            return response.data;
        }
    );
}

export type EpayBankData = {
    /**
     * {
     *       "locationId": "10107170",
     *       "bankId": "1810",
     *       "bankName": "SYNDICATE BANK",
     *       "bankBranch": "SYNDICATE BANK",
     *       "address": "SYNDICATE BANK",
     *       "city": "India",
     *       "currency": "INR",
     *       "countryCode": "IN",
     *       "transactionType": "B2C",
     *       "channelCode": "43"
     *     },
     */
    locationId: string;
    bankId: string;
    bankName: string;
    bankBranch: string;
    address: string;
    city: string;
    currency: string;
    countryCode: string;
    transactionType: string;
    channelCode: string;
}

export type EpayBankListPagination = {
    page: number;
    pagesize: number;
    total: number;
    pages: number;
}

export type EpayBankListData = {
    banks: EpayBankData[];
    p: EpayBankListPagination
}


export const fetchEpayIndiaBanks = async (search = null,
                                          page = 0,
                                          pagesize = 100): Promise<EpayBankListData> => {
    return await httpAxiosApi.post('/webapi/finance/epy/indiaBanks', {
        m: {
            search: search,
            page: page,
            pagesize: pagesize
        }
    }).then(
        (response) => {
            return {...response.data};
        }
    );
}


export const fetchEpayIndonesiaBanks = async (search = null,
                                          page = 0,
                                          pagesize = 100): Promise<EpayBankListData> => {
    return await httpAxiosApi.post('/webapi/finance/epy/indonesiaBanks', {
        m: {
            search: search,
            page: page,
            pagesize: pagesize
        }
    }).then(
        (response) => {
            return {...response.data};
        }
    );
}